export const START_GET_MY_REFERRALS = "START_GET_MY_REFERRALS";
export const SUCCESS_GET_MY_REFERRALS = "SUCCESS_GET_MY_REFERRALS";
export const ERROR_GET_MY_REFERRALS = "ERROR_GET_MY_REFERRALS";
